import React from 'react'
import { withTranslation } from 'react-i18next'
import { PieChart, Pie, Cell } from 'recharts'

export default withTranslation()(function WinnersByStatusCard({ t, paid = 0, paidAmount = 'GHS 0.00', verified = 0, verifiedAmount = 'GHS 0.00', pending = 0, pendingAmount = 'GHS 0.00' }) {
  const segments = [
    { key: 'paid', label: t('payout.winners_by_status.paid'), color: '#34C759', value: paid, amount: paidAmount },
    { key: 'verified', label: t('payout.winners_by_status.verified'), color: '#1976D2', value: verified, amount: verifiedAmount },
    { key: 'pending', label: t('payout.winners_by_status.pending'), color: '#FF9500', value: pending, amount: pendingAmount }
  ]
  const total = segments.reduce((sum, segment) => sum + segment.value, 0)
  const chartData = total > 0 ? segments : [{ key: 'empty', color: '#E6EBF0', value: 1 }]

  return (
    <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4 flex flex-col gap-6">
      <p className="text-sm font-semibold text-dark-blue tracking-wide uppercase">{t('payout.winners_by_status.title')}</p>

      <div className="flex items-center gap-6">
        <div className="relative shrink-0 w-[150px] h-[150px]">
          <PieChart width={150} height={150}>
            <Pie data={chartData} dataKey="value" cx="50%" cy="50%" innerRadius={54} outerRadius={75} stroke="none">
              {chartData.map((segment) => <Cell key={segment.key} fill={segment.color} />)}
            </Pie>
          </PieChart>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
            <p className="text-xs text-secondary">{t('payout.winners_by_status.total_winners')}</p>
            <p className="text-lg font-bold text-dark-blue">{total}</p>
          </div>
        </div>

        <div className="flex-1 flex flex-col">
          {
            segments.map((segment) => (
              <div key={segment.key} className="flex items-center gap-2 py-1.5">
                <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: segment.color }} />
                <p className="text-sm text-secondary whitespace-nowrap">{segment.label}</p>
                <p className="flex-1 text-sm text-dark-blue text-right">{segment.amount}</p>
                <p className="text-sm text-secondary text-right w-[50px]">{total ? `${Math.round((segment.value / total) * 100)}%` : '0%'}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
})
